// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__3bbqf","content":"RecentSearches_content__-p9pC"};